"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: notification/template.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fnotification%2Ftemplate.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTemplate = exports.SmsTemplate = exports.PushTemplate = exports.TemplateData = void 0;
const message_service_type_1 = require("../phone/message-service-type");
const protobufPackage = 'com.step.notification.proto';
function createBaseTemplateData() {
    return { push: undefined, sms: undefined, email: undefined };
}
exports.TemplateData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.push)) {
            message.push = exports.PushTemplate.fromJSON(object.push);
        }
        if (isSet(object.sms)) {
            message.sms = exports.SmsTemplate.fromJSON(object.sms);
        }
        if (isSet(object.email)) {
            message.email = exports.EmailTemplate.fromJSON(object.email);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.push !== undefined) {
            obj.push = exports.PushTemplate.toJSON(message.push);
        }
        if (message.sms !== undefined) {
            obj.sms = exports.SmsTemplate.toJSON(message.sms);
        }
        if (message.email !== undefined) {
            obj.email = exports.EmailTemplate.toJSON(message.email);
        }
        return obj;
    },
    create(base) {
        return exports.TemplateData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTemplateData();
        message.push = (object.push !== undefined && object.push !== null)
            ? exports.PushTemplate.fromPartial(object.push)
            : undefined;
        message.sms = (object.sms !== undefined && object.sms !== null)
            ? exports.SmsTemplate.fromPartial(object.sms)
            : undefined;
        message.email = (object.email !== undefined && object.email !== null)
            ? exports.EmailTemplate.fromPartial(object.email)
            : undefined;
        return message;
    },
};
function createBasePushTemplate() {
    return { title: '', body: '', emojis: [] };
}
exports.PushTemplate = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title) ? globalThis.String(object.title) : '',
            body: isSet(object.body) ? globalThis.String(object.body) : '',
        };
        if (globalThis.Array.isArray(object?.emojis)) {
            message.emojis = object.emojis.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.body !== '') {
            obj.body = message.body;
        }
        if (message.emojis?.length) {
            obj.emojis = message.emojis;
        }
        return obj;
    },
    create(base) {
        return exports.PushTemplate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePushTemplate();
        message.title = object.title ?? '';
        message.body = object.body ?? '';
        message.emojis = object.emojis?.map((e) => e) || [];
        return message;
    },
};
function createBaseSmsTemplate() {
    return { body: '', messageServiceType: message_service_type_1.MessageServiceType.INVALID_MESSAGE_SERVICE_TYPE };
}
exports.SmsTemplate = {
    fromJSON(object) {
        const message = { body: isSet(object.body) ? globalThis.String(object.body) : '' };
        if (isSet(object.messageServiceType)) {
            message.messageServiceType = (0, message_service_type_1.messageServiceTypeFromJSON)(object.messageServiceType);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.body !== '') {
            obj.body = message.body;
        }
        if (message.messageServiceType !== undefined &&
            message.messageServiceType !== message_service_type_1.MessageServiceType.INVALID_MESSAGE_SERVICE_TYPE) {
            obj.messageServiceType = (0, message_service_type_1.messageServiceTypeToJSON)(message.messageServiceType);
        }
        return obj;
    },
    create(base) {
        return exports.SmsTemplate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSmsTemplate();
        message.body = object.body ?? '';
        message.messageServiceType = object.messageServiceType ??
            message_service_type_1.MessageServiceType.INVALID_MESSAGE_SERVICE_TYPE;
        return message;
    },
};
function createBaseEmailTemplate() {
    return {
        fromEmail: '',
        fromName: '',
        replyTo: '',
        bcc: [],
        subject: '',
        body: '',
        remoteTemplateId: '',
    };
}
exports.EmailTemplate = {
    fromJSON(object) {
        const message = {
            subject: isSet(object.subject) ? globalThis.String(object.subject) : '',
            body: isSet(object.body) ? globalThis.String(object.body) : '',
            remoteTemplateId: isSet(object.remoteTemplateId)
                ? globalThis.String(object.remoteTemplateId)
                : '',
        };
        if (isSet(object.fromEmail)) {
            message.fromEmail = globalThis.String(object.fromEmail);
        }
        if (isSet(object.fromName)) {
            message.fromName = globalThis.String(object.fromName);
        }
        if (isSet(object.replyTo)) {
            message.replyTo = globalThis.String(object.replyTo);
        }
        if (globalThis.Array.isArray(object?.bcc)) {
            message.bcc = object.bcc.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fromEmail !== undefined && message.fromEmail !== '') {
            obj.fromEmail = message.fromEmail;
        }
        if (message.fromName !== undefined && message.fromName !== '') {
            obj.fromName = message.fromName;
        }
        if (message.replyTo !== undefined && message.replyTo !== '') {
            obj.replyTo = message.replyTo;
        }
        if (message.bcc?.length) {
            obj.bcc = message.bcc;
        }
        if (message.subject !== '') {
            obj.subject = message.subject;
        }
        if (message.body !== '') {
            obj.body = message.body;
        }
        if (message.remoteTemplateId !== '') {
            obj.remoteTemplateId = message.remoteTemplateId;
        }
        return obj;
    },
    create(base) {
        return exports.EmailTemplate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEmailTemplate();
        message.fromEmail = object.fromEmail ?? '';
        message.fromName = object.fromName ?? '';
        message.replyTo = object.replyTo ?? '';
        message.bcc = object.bcc?.map((e) => e) || [];
        message.subject = object.subject ?? '';
        message.body = object.body ?? '';
        message.remoteTemplateId = object.remoteTemplateId ?? '';
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=template.js.map